import {Injectable} from '@angular/core';
import {ConfigService} from 'app/core/services/config.service';
import {RequestService} from 'app/core/services/request.service';
import {Observable} from 'rxjs';

@Injectable()
export class PlatformPriceListService {

    private allConfigurations : any = null;

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    getPriceListTableAPIUrl() {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.fetchPriceList.api;
    }

    getPricesListItemDetails(id) {
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.fetchPriceListItemDetails.api + '/' + id
        ).map(_ => _.data);
    }

    getSupportedCurrencies() {
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.currency.api
        ).map(_ => _.data);
    }

    getPricesTableAPIUrl() {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.fetchPrices.api;
    }

    fetchAllConfigurations() {
        if (this.allConfigurations) {
            return Observable.of(this.allConfigurations);
        }
        return Observable.forkJoin([
            this.fetchSellerRegions(),
            this.fetchAccountTypes(),
            this.fetchPriceListType(),
            this.fetchAccountAccreditations(),
            this.fetchDomains(),
            this.fetchBuyerAccountList()
        ]).map(([regions,accountTypes,priceListTypes,accountAccrs,domains,buyerAccountList]) => {
            this.allConfigurations = {regions,accountTypes,priceListTypes,accountAccrs,domains,buyerAccountList};
            return this.allConfigurations;
        })
    }

    fetchAccountAccreditations() {
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.accountAccreditations.api
        ).map(_ => _.data);
    }

    fetchSellerRegions() {
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.sellerRegions.api
        ).map(_ => _.data);
    }

    fetchAccountTypes() {
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.accountTypes.api
        ).map(_ => _.data);
    }

    fetchPriceListType() {
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.priceListType.api
        ).map(_ => _.data);
    }

    fetchDomains() {
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.domainList.api
        ).map(_ => _.data);
    }

    fetchBuyerAccountList() {
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.buyerAccountList.api
        ).map(_ => _.data);
    }

    savePriceList(payload) {
        return this.requestService.post(
            this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.savePriceList.api,
            payload
        ).map(_ => _.data);
    }

    updatePriceList(payload) {
        return this.requestService.post(
            this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.updatePriceList.api,
            payload
        ).map(_ => _.data);
    }

    deletePriceList(payload) {
        return this.requestService.post(
            this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.deletePriceList.api,
            payload
        ).map(_ => _.data);
    }

    findProductBySKU(sku, id) {
        const urlSuffix = '?sku=' + sku + '&id=' + id;
        return this.requestService.get(
            this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.fetchProductBySKU.api + urlSuffix
        ).map(_ => _.data);
    }

    createProductForPrice(payload) {
        return this.requestService.post(
            this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.createProductForPrice.api,
            payload
        ).map(_ => _.data);
    }

    editProductForPrice(payload) {
        return this.requestService.post(
            this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.editProductForPrice.api,
            payload
        ).map(_ => _.data);
    }

    deleteProductPrice(payload) {
        return this.requestService.post(
            this.configService.get('server').url + this.configService.get('endpoints').agora.priceList.deleteProductPrice.api,
            payload
        ).map(_ => _.data);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/pricing-data/pricing-list/platform-price-list.service.ts